import { useMutation } from '@tanstack/react-query';
import { postRegistrationOperator, postRegistrationOperatorUser } from 'api/requests/requests';
import { AxiosError } from 'axios';
import { AccountInvitationRegistrationSchemaType } from 'components/forms/AccountFactory/types';
import { RegistrationResponseSchemaType } from 'components/forms/types';
import { setCookies } from 'utils/cookie-helpers';
import { OperatorRegistrationPayload } from 'utils/data/data-types';

export const registrationQueryKeys = {
  all: ['registration'] as const,
  operator: () => [...registrationQueryKeys.all, 'operator'] as const,
  operatorUser: () => [...registrationQueryKeys.all, 'operator-user'] as const,
};

export function usePostRegistrationOperatorMutation() {
  return useMutation<RegistrationResponseSchemaType, AxiosError, OperatorRegistrationPayload>({
    mutationKey: registrationQueryKeys.operator(),
    mutationFn: (v) => postRegistrationOperator(v).then((d) => d.data),
    onSuccess: async (data) => {
      await setCookies(data);
    },
  });
}

export function usePostRegistrationOperatorUserMutation() {
  return useMutation<
    RegistrationResponseSchemaType,
    AxiosError,
    AccountInvitationRegistrationSchemaType
  >({
    mutationKey: registrationQueryKeys.operatorUser(),
    mutationFn: (v) => postRegistrationOperatorUser(v).then((d) => d.data),
    onSuccess: async (data) => {
      await setCookies(data);
    },
  });
}
